import Vue from 'vue'
import App from './App.vue'

//Importation des modules supplémentaire
import VueRouter from 'vue-router'
//Importation d'Axios
import axios from 'axios'

//Vue Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//Importation des routes
import {routes} from './routes';

Vue.use(VueRouter)
Vue.use(BootstrapVue)


const router= new VueRouter({
  routes,
  mode:'history',
  scrollBehavior(to, from, savedPosition){
    if(savedPosition){
      return savedPosition;
    }
    else {
      return { x: 0, y: 0 }
    }
    if(to.hash){
      return {selector:to.hash};
    }
  }
})

//Leaflet global
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

//Font-Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTimesCircle)
library.add(faChevronCircleDown)
library.add(faChevronCircleUp)
library.add(faInfo)
library.add(faInfoCircle)
library.add(faPlusCircle)
library.add(faBars)
library.add(faFacebookSquare)
library.add(faTwitterSquare)
library.add(faInstagramSquare)

//Traduction
import {i18n} from './plugins/i18n'
Vue.component('font-awesome-icon', FontAwesomeIcon)

import { VueReCaptcha } from 'vue-recaptcha-v3'

// For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LfjIoAbAAAAALkKQoKV1nVEhphy5EaQc-CWSwfn' })

import store from './store'
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})







// WEBPACK FOOTER //
// ./src/main.js